import { useAchievementNotification } from "@/contexts/AchievementNotificationContext";
import type { Achievement } from "@/hooks/useAchievements";

const safeFallback = {
  showNotification: (_achievement: Achievement) => {},
  hideNotification: () => {},
  skipAll: () => {},
  currentAchievement: null as Achievement | null,
  isOpen: false,
  queueLength: 0,
};

let warnedOnce = false;

/**
 * Safety wrapper to avoid blank screens if context/provider mismatch happens (often during hot reload).
 * Logs a warning in dev instead of throwing.
 */
export function useAchievementNotificationSafe() {
  try {
    return useAchievementNotification();
  } catch (err) {
    if (import.meta.env.DEV && !warnedOnce) {
      warnedOnce = true;
      console.warn(
        "[AchievementNotification] AchievementNotificationProvider missing or mismatched. Notifications will be disabled until it is mounted.",
        err
      );
    }
    return safeFallback;
  }
}
